<template>
  <div>
    <div class="template-wrapper">
      <span class="font-semibold">
        {{getPracticeName()}}
          <span v-bind:class="{ 'bg-primary' : getType() === 'powder', 'bg-warning' : getType() === 'liquid' }"
                class="blur-lg inline-flex items-center justify-center px-2 py-1 text-xs font-normal leading-none text-white rounded">
            {{getType()}}
          </span>
      </span>
      <br>
      {{getName()}}
    </div>
  </div>
</template>

<script>
  export default {
    name: "resourceHeaderTemplate",
    data() {
      return {
        data: ''
      }
    },
    methods: {
      getPracticeName() {
        const value = JSON.parse(JSON.stringify(this.data));
        return value.resourceData.text
      },
      getName() {
        const value = JSON.parse(JSON.stringify(this.data));
        return value.resourceData.production_line_name
      },
      getType() {
        const value = JSON.parse(JSON.stringify(this.data));
        return value.resourceData.production_line_type
      },
    },
    mounted() {

    }
  }
</script>

<style scoped>

</style>
